<script>
import ViewMixin from './view'
import AccountEditor from '../../../components/account-editor/account-editor.vue'

export default {
  mixins: [
    ViewMixin
  ],

  components: {
    'artup-account-editor': AccountEditor
  }
}
</script>

<template>
  <main class="artup-account-view my-account">
    <artup-account-editor :id="account.id" embedded>
    </artup-account-editor>
  </main>
</template>

<style scoped lang="scss">
@import "./view.scss";
</style>
